import {EventEmitter, Injectable} from '@angular/core';
import {tap} from "rxjs/operators";
import {User} from "../../models/user";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private readonly JWT_TOKEN = 'JWT_TOKEN';
    private readonly USER_DATA = 'USER_DATA';

    constructor(
        protected http: HttpClient
    ) {}

    login(email, password) {
        return this.http.post('/api/v1/login', {
            email, password
        }).pipe(
            tap(data => {
                localStorage.clear();
                localStorage.setItem(this.JWT_TOKEN, data['data']['authorization']);

                this.setUser(new User(data['data']['user']));
                // this.loginEvent.emit(true);
            })
        );
    }

    register(email, password) {
        return this.http.post('/api/v1/register', {
            email, password
        }).pipe(
            tap(data => {
                localStorage.setItem(this.JWT_TOKEN, data['data']['authorization']);

                this.setUser(new User(data['data']['user']));

                // this.loginEvent.emit(true);
            })
        );
    }

    askPasswordRecovery(email) {
        return this.http.post('/api/v1/recovery', {email});
    }

    doPasswordRecovery(email, token, password) {
        return this.http.patch(`/api/v1/recovery?e=${email}&t=${token}`, {password}).pipe(
          tap(data => {
            localStorage.clear();
            localStorage.setItem(this.JWT_TOKEN, data['data']['authorization']);

            this.setUser(new User(data['data']['user']));
            // this.loginEvent.emit(true);
          })
        );
    }

    isLoggedIn() {
        return !!this.getJwtToken();
    }

    isAdmin() {
        return this.getUser().role === 'admin';
    }

    getJwtToken() {
        return localStorage.getItem(this.JWT_TOKEN);
    }

    logout() {
        localStorage.clear();
    }

    setUser(user: User) {
        localStorage.setItem(this.USER_DATA, JSON.stringify({...user.getObj(), projects: []}));
    }

    getUser() {
        return new User(JSON.parse(localStorage.getItem(this.USER_DATA)));
    }
}
